import React from "react";
import Lightbox from "yet-another-react-lightbox";
import { gallery_utils } from "../utils/GalleryUtils";
import "yet-another-react-lightbox/styles.css";

const LightboxComponent = ({ handleOpenLightbox, open, close }) => {
  const generateSlides = () => {
    // Assuming tour.image is an array of image URLs
    return gallery_utils.map((item, index) => ({
      src: `${item.img}`,
      //   alt: `Image ${index + 1}`,
      width: 1520,
      height: 1313,
    }));
  };

  return <Lightbox open={open} close={close} slides={generateSlides()} />;
};

export default LightboxComponent;
